import { Delete, DoNotDisturb, Edit } from '@mui/icons-material';
import { Box, Card, CardContent, CardHeader, IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Tooltip } from '@mui/material'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import { postSubmit } from 'global/postFunc';
import { postDelete } from 'global/postFunc';
import InputLaporan from 'pages/adminOpd/LaporanBelanja/InputLaporan';
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore';
import Swal from 'sweetalert2';

const listBulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
];

const getMonth = () => {
    const d = new Date();
    let month = d.getMonth();
    return month
}

// const isEnable = (params) => {
//     const d = new Date();
//     let month = d.getMonth();
//     let tgl = d.getDate();

//     if (params < month - 1 || params > month) {
//         return false
//     }
//     else {
//         if (params === month - 1) {
//             if (tgl > 5) {
//                 return false
//             }
//             else {
//                 return true
//             }
//         }
//         else {
//             return true
//         }
//     }
// }

const getRealisasiKeuangan = (index, listRealisasi) => {
    let realisasi = listRealisasi.find(x => parseInt(x.bulan) === index)

    let output = realisasi ?
        parseInt(realisasi.realisasi_keuangan).toLocaleString?.('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
        : ''

    return output
}

const getRealisasiKeuanganPersen = (index, listRealisasi) => {
    let realisasi = listRealisasi.find(x => parseInt(x.bulan) === index)

    let output = realisasi ?
        parseInt(realisasi.realisasi_keuangan_persen) + "%"
        : ''

    return output
}

const getRealisasiFisik = (index, listRealisasi, dataKomponen) => {
    let realisasi = listRealisasi.find(x => parseInt(x.bulan) === index);

    let output = realisasi ?
        dataKomponen.metode_pengadaan === 'Swakelola' && parseInt(dataKomponen.volume) > 1 ?
            realisasi.realisasi_fisik_persen ? realisasi.realisasi_fisik + ' (' + realisasi.realisasi_fisik_persen + '%)' : ''
            :
            realisasi.realisasi_fisik_persen ? realisasi.realisasi_fisik_persen + '%' : ''
        :
        ""

    return output
}

const getRealisasiBulan = (index, listRealisasi, dataKomponen) => {
    let realisasi = listRealisasi.find(x => parseInt(x.bulan) === index)

    let output = realisasi ?
        parseInt(realisasi.bulan)
        : ''

    return output
}

const getStatusPelaksanaan = (index, listRealisasi) => {
    let realisasi = listRealisasi.find(x => parseInt(x.bulan) === index);

    let output = realisasi ?
        realisasi.status_pelaksanaan ? realisasi.status_pelaksanaan : ''
        :
        ""

    return output
}

const CapaianBulanan = ({ dataKomponen, idKomponen, updating, setUpdating }) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    useEffect(() => {
        reqRealisasi()
        console.log(updating);
        console.log(idKomponen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    useEffect(() => {
        console.log(dataKomponen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataKomponen])

    const deleteRealisasi = (index, listRealisasi) => {
        let realisasi = listRealisasi.find(x => parseInt(x.bulan) === index)
        Swal.fire({
            title: `Hapus Data?`,
            text: `Progres bulan ${realisasi.bulan} akan Dihapus`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/admin-opd/realisasi/delete',
                    {
                        _method: 'DELETE',
                        id: realisasi.id,
                        id_komponen: dataKomponen.id
                    },
                    decryptedUser,
                    null,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }

    const setNihil = (bulan) => {
        addReq()
        postSubmit(
            '/admin-opd/realisasi/set-nihil',
            {
                _method: 'PUT',
                realisasi_keuangan: 0,
                realisasi_keuangan_persen: 0,
                realisasi_fisik: 0,
                realisasi_fisik_persen: 0,
                id_komponen: dataKomponen.id,
                ta: dataKomponen.ta,
                kd_pd: dataKomponen.kd_pd,
                kd_subkegiatan: dataKomponen.kd_subkegiatan,
                kd_sub_rincian_objek: dataKomponen.kd_sub_rincian_objek,
                nama_sub_rincian_objek: dataKomponen.nama_sub_rincian_objek,
                nama_komponen: dataKomponen.nama_komponen,
                bulan: bulan,
            },
            decryptedUser,
            (res) => {
                setUpdating(!updating)
            },
            null
            // (res) => {
            //     setSaving(false)
            // }
        )
    }

    const [listRealisasi, setListRealisasi] = useState([])
    const [dataRealisasi, setDataRealisasi] = useState({})

    const reqRealisasi = () => {
        addReq()
        postDataWithResponse(
            `/admin-opd/realisasi/filter`,
            {
                id_komponen: idKomponen
            },
            decryptedUser,
            (res) => {
                setListRealisasi(res)
                console.log(res);

            },
            (res) => {
                console.log(res)
            }
        )
    }

    const [inputRealisasi, setInputRealisasi] = useState(false)
    const [bulan, setBulan] = useState('');

    const handleCloseDialog = () => {
        setInputRealisasi(false)
    }

    const editClick = (index, bln) => {
        // console.log(listRealisasi);
        // console.log(bln);
        // console.log(index + 1);

        setBulan(index + 1)
        const filterData = listRealisasi.find(item => item.bulan === String(index + 1))
        setDataRealisasi(filterData ? filterData : {})
        setInputRealisasi(true)
        // console.log(filterData);

    }

    const [isRealisasi, setIsRealisasi] = useState(false)

    return (
        <Card>
            <CardHeader
                title={
                    <ArgonTypography variant='subtitle2' fontWeight="bold">Capaian Bulanan</ArgonTypography>
                }
            />
            <CardContent>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                No
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Bulan
                            </TableCell>
                            <TableCell align="center" colSpan={2} sx={{ fontSize: 'small' }}>
                                Realisasi Keuangan
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Realisasi Fisik
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Status Pelaksanaan
                            </TableCell>
                            <TableCell align="center" rowSpan={2} sx={{ fontSize: 'small' }}>
                                Aksi
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" sx={{ fontSize: 'small' }}>
                                Nominal (Rp)
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small' }}>
                                %
                            </TableCell>
                            {/* <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        Volume
                                    </TableCell> */}
                            {/* <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        Bobot
                                    </TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            listBulan.map((bln, index) => (
                                <TableRow key={index} >
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>{index + 1}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>{bln}</TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            getRealisasiKeuangan(index + 1, listRealisasi)
                                        }
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            getRealisasiKeuanganPersen(index + 1, listRealisasi)
                                            // listRealisasi[index]?.realisasi_keuangan_persen ? listRealisasi[index].realisasi_keuangan_persen + '%' : ''
                                        }
                                    </TableCell>

                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            getRealisasiFisik(index + 1, listRealisasi, dataKomponen)
                                        }
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }}>
                                        {
                                            getStatusPelaksanaan(index + 1, listRealisasi)
                                        }
                                    </TableCell>
                                    <TableCell align="center" sx={{ fontSize: 'small' }} color='inherit'>
                                        <Box>
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    onClick={() => {
                                                        editClick(index, bln)
                                                        // setInputRealisasi(true)
                                                        // setBulan(index + 1)
                                                        // setDataRealisasi(listRealisasi[index] ? listRealisasi[index] : {})
                                                        // setDataRealisasi(listRealisasi[index])
                                                    }}
                                                >
                                                    <Edit fontSize='small' color="info" />
                                                </IconButton>
                                            </Tooltip>
                                            {
                                                getRealisasiBulan(index + 1, listRealisasi) === index+1 &&
                                                <Tooltip title="Hapus">
                                                    <IconButton
                                                        onClick={() => {
                                                            deleteRealisasi(index + 1, listRealisasi)
                                                        }}
                                                    >
                                                        <Delete fontSize='small' color="error" />
                                                    </IconButton>
                                                </Tooltip>
                                                    // getRealisasiBulan(index + 1, listRealisasi)
                                            }
                                        </Box>

                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={2} sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                Total
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                {
                                    parseInt(dataKomponen.realisasi_keuangan).toLocaleString?.('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    })
                                }
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                {dataKomponen.realisasi_keuangan_persen} %
                            </TableCell>
                            <TableCell align="center" sx={{ fontSize: 'small', fontWeight: 'bold' }}>
                                {dataKomponen.realisasi_fisik_persen} %
                            </TableCell>
                            <TableCell align="center" colSpan={2} sx={{ fontSize: 'small', fontWeight: 'bold' }}>

                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </CardContent>

            <InputLaporan
                decryptedUser={decryptedUser}
                addReq={addReq}
                open={inputRealisasi}
                handleClose={handleCloseDialog}
                dataKomponen={dataKomponen}
                dataRealisasi={dataRealisasi}
                bulan={bulan}
                updating={updating}
                setUpdating={setUpdating}
            />
        </Card>
    )
}

export default CapaianBulanan